import React from "react";
import Ellipsis from "./Ellipsis";

//TODO: rename
const CenteredLoading: React.FC = () => {
  return (
    <div className="flex justify-start text-sm">
      Loading
      <Ellipsis />
    </div>
  );
};

export default CenteredLoading;
